var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 11.8C22.6667 9.99653 21.9643 8.26692 20.714 6.99167C19.4638 5.71643 17.7681 5 16 5C14.2319 5 12.5362 5.71643 11.286 6.99167C10.0357 8.26692 9.33333 9.99653 9.33333 11.8C9.33333 19.7333 6 22 6 22H26C26 22 22.6667 19.7333 22.6667 11.8Z",
    fill: "#0045F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26C17.7968 26.3042 17.505 26.5566 17.154 26.7321C16.803 26.9076 16.4051 27 16 27C15.5949 27 15.197 26.9076 14.846 26.7321C14.495 26.5566 14.2032 26.3042 14 26",
    stroke: "#0045F5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.125edd1614662b36c4f635ef29a2b68b.svg";
export { ForwardRef as ReactComponent };